export { WrappedFooter as Footer, Footer as PureFooter } from "./Footer";